(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breast-cancer-product"]) return;
  try {
    
function initAwarenessForms(root=document){
root.querySelectorAll('.bc-multi-form').forEach(form=>{
if(form.dataset.ready)return;form.dataset.ready='true';
const style=form.querySelector('.bc-style'),fields=form.querySelector('.bc-order-fields'),request=form.querySelector('.bc-style-request'),rows=form.querySelector('.bc-size-rows'),status=form.querySelector('.bc-order-status');
function filterSizes(){rows.querySelectorAll('select').forEach(select=>{let first=-1;[...select.options].forEach((opt,i)=>{const match=opt.dataset.style===style.value;opt.hidden=!match;opt.disabled=!match||opt.dataset.available!=='true';if(match&&!opt.disabled&&first<0)first=i;});select.selectedIndex=first;});} function setStyle(){const order=!!style.value;fields.hidden=!order;request.hidden=true;filterSizes();fields.querySelectorAll('input,select,textarea,button').forEach(el=>{if(el.type==='submit')el.disabled=!order||el.textContent.trim()==='Currently Unavailable';else el.disabled=!order;});}
style.addEventListener('change',setStyle);setStyle();
form.querySelector('.bc-add-size').addEventListener('click',()=>{const row=rows.firstElementChild.cloneNode(true);row.querySelector('input').value='1';row.querySelector('select').selectedIndex=rows.firstElementChild.querySelector('select').selectedIndex;row.querySelector('.bc-remove-size').hidden=false;rows.appendChild(row);row.querySelector('select').focus();});
rows.addEventListener('click',e=>{if(e.target.matches('.bc-remove-size'))e.target.closest('.bc-size-row').remove();});
form.addEventListener('submit',async e=>{
e.preventDefault();if(!form.reportValidity())return;
const selected=[...rows.querySelectorAll('.bc-size-row')];const submit=form.querySelector('[type=submit]');submit.disabled=true;status.textContent='Adding your shirts…';let added=0;
try{
const sharedData=new FormData(form);for(const row of selected){
const data=new FormData();for(const [key,value] of sharedData.entries())data.append(key,value);data.set('id',row.querySelector('select').value);data.set('quantity',row.querySelector('input').value);
const endpoint=form.action;const response=await fetch(endpoint,{method:'POST',body:data,credentials:'same-origin'});
if(!response.ok)throw new Error('Unable to add this size.');added++;row.remove();
}
window.location.assign((window.Shopify?.routes?.root||'/')+'cart');
}catch(error){status.textContent=added+' size row(s) added. Remaining rows were not added. Please check your cart before retrying.';const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/')+'cart';link.textContent=' View cart';status.append(link);submit.disabled=false;}
});
});
}
initAwarenessForms();document.addEventListener('shopify:section:load',event=>initAwarenessForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cottondale-product"]) return;
  try {
    
document.addEventListener('change',function(event){if(event.target.id!=='CottondaleVariant')return;var option=event.target.selectedOptions[0];document.getElementById('CottondalePrice').textContent=option.dataset.price;var button=document.getElementById('CottondaleAdd');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold Out':'Add to Cart';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jayden-curry-product"]) return;
  try {
    
document.addEventListener('change',function(event){if(event.target.id!=='CottondaleVariant')return;var option=event.target.selectedOptions[0];document.getElementById('CottondalePrice').textContent=option.dataset.price;var button=document.getElementById('CottondaleAdd');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold Out':'Add to Cart';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
